import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import { useOOGlobals } from '../OOGlobalsProvider/OOGlobalsProvider'
import { MultiLocationPage } from '../MultiLocationPage/MultiLocationPage'

export const MultiLocationPickerApp = () => {
  const { routerBasename } = useOOGlobals()

  return (
    <React.Fragment>
      <BrowserRouter basename={routerBasename}>
        <Switch>
          <Route component={MultiLocationPage} exact path='/' />
          <Redirect to='/' />
        </Switch>
      </BrowserRouter>
    </React.Fragment>
  )
}
